import { extractYouTubeId } from "@/lib/youtube";

export type CourseVideoSource = {
  kind: "embed" | "direct";
  provider: "youtube" | "google-drive" | "direct";
  src: string;
};

const GOOGLE_DRIVE_FILE_PATH = /^\/file\/d\/([^/]+)(?:\/|$)/;
const DIRECT_VIDEO_PATH = /\.(?:mp4|webm|ogg|ogv|mov|m4v)$/i;

export function resolveCourseVideoSource(
  videoUrl: string | null | undefined
): CourseVideoSource | null {
  if (!videoUrl) return null;

  const youtubeId = extractYouTubeId(videoUrl);
  if (youtubeId) {
    return {
      kind: "embed",
      provider: "youtube",
      src: `https://www.youtube.com/embed/${youtubeId}?autoplay=0&rel=0&modestbranding=1&fs=1`,
    };
  }

  try {
    const url = new URL(videoUrl);
    if (url.hostname === "drive.google.com") {
      const fileId = url.pathname.match(GOOGLE_DRIVE_FILE_PATH)?.[1];
      if (!fileId) return null;

      return {
        kind: "direct",
        provider: "google-drive",
        src: `https://drive.usercontent.google.com/download?id=${fileId}&export=download&authuser=0&confirm=t`,
      };
    }

    if (!["http:", "https:"].includes(url.protocol)) return null;
    if (!DIRECT_VIDEO_PATH.test(url.pathname)) return null;

    return {
      kind: "direct",
      provider: "direct",
      src: videoUrl,
    };
  } catch {
    return null;
  }
}
